<template>
  <div class="calendar-wrapper">
    <!-- <el-date-picker v-model="dateValue" type="daterange" :clearable="false" range-separator="~"
      start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
      @change="handleChange" style="width: 100%">
    </el-date-picker> -->
    <el-date-picker
      :editable="false"
      :disabled="disabled"
      v-model="timevalue1"
      type="daterange"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      range-separator="~"
      value-format="yyyy-MM-dd"
      format="yyyy-MM-dd"
      @change="changeTime"/>
    <x-file-icon class="icon" :type="'calendar'" :width="'14px'"></x-file-icon>
  </div>
</template>

<script>
  export default {
    name: 'XDatePickerRange',
    // model: {
    //   prop: 'result',
    //   event: 'handleResult'
    // },
    // props: {
    //   result: [Array],
    // },
    model: {
      prop: 'timevalue',
      event: 'change'
    },
    props: {
      timevalue: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        // dateValue: [],
        timevalue1: [],
      }
    },
    watch: {
      timevalue: {
        immediate: true,
        handler(val) {
          if (val.length > 0) {
            this.timevalue1 = val
          }
          if (val == null) {
            // this.timevalue1 = []
            this.$emit('change', [])
            return
          }
          // console.log('timevalue', val)
          this.$emit('change', val)
        }

      },
      timevalue1: {
        immediate: true,
        handler(newVal) {
          if (newVal == null) {
            // this.timevalue1 = []
            this.$emit('change', [])
            return
          }
          // console.log('timevalue1', newVal)
          this.$emit('change', newVal)
        }

      }
    },
    methods: {
      changeTime(val) {
        // var oval = this.moment(val).format('YYYY-MM-DD HH:mm:ss')
        console.log(val)
        if (val == null) {
          // val = []
          this.$emit('change', [])
          return
        }
        this.$emit('change', val)
      },
      // handleChange () {
      //   this.$emit('handleResult', this.dateValue)
      // },
      handleClean () {
        this.timevalue1 = []
      }
  }
}
</script>

<style lang="scss" scoped>
.calendar-wrapper {
  height: 100%;
  position: relative;
  // margin-top: 3px;

  .icon {
    position: absolute;
    top: 0;
    right: 46px;
    bottom: 0;
    margin: auto;
  }
}

::v-deep .el-date-editor {
  width: calc(100% - 36px);
  padding: 6px 12px !important;

  .el-range__icon {
    display: none !important;
  }

  .el-range-input {
    text-align: left;
    font-size: 12px !important;
    width: 40% !important;
  }

  .el-range-separator {
    height: 32px;
    line-height: 32px;
    color: #C2C2C2 !important;
  }
}
</style>
